import React from 'react';
import ReactDOM from 'react-dom';

import core from '~/core/scripts';
import MapWrapper from './scripts/Map';

import './styles/index.styl';

if (module.hot) {
  // we only want HMR enabled for stylus files
  module.hot.accept(/\.styl$/);
}

core.init();

ReactDOM.render((
  <MapWrapper />
), document.getElementById('map'));
